function clamp(n, min, max) {
    return Math.max(min, Math.min(max, n));
}

function getClosestIndex(track, items) {
    const left = track.scrollLeft;
    let bestIndex = 0;
    let bestDistance = Infinity;

    for (let i = 0; i < items.length; i++) {
        const d = Math.abs(items[i].offsetLeft - left);
        if (d < bestDistance) {
            bestDistance = d;
            bestIndex = i;
        }
    }
    return bestIndex;
}

function createControls(doc) {
    const controls = doc.createElement("div");
    controls.className = "carousel-controls";

    const prev = doc.createElement("button");
    prev.type = "button";
    prev.className = "carousel-controls__prev";
    prev.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18">
      <g fill="currentColor">
        <path d="M15 8.25H5.87l4.19-4.19L9 3 3 9l6 6 1.06-1.06-4.19-4.19H15v-1.5z"></path>
      </g>
    </svg> <span class="sr-only">Previous</span>`;
    prev.setAttribute("aria-label", "Previous");

    const next = doc.createElement("button");
    next.type = "button";
    next.className = "carousel-controls__next";
    next.innerHTML = `<span class="sr-only">Next</span> <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18">
      <g fill="currentColor">
        <path d="M9 3L7.94 4.06l4.19 4.19H3v1.5h9.13l-4.19 4.19L9 15l6-6z"></path>
      </g>
    </svg>`;
    next.setAttribute("aria-label", "Next");

    controls.appendChild(prev);
    controls.appendChild(next);

    return {controls, prev, next};
}

export function initCarousel() {
    const carousels = Array.from(document.querySelectorAll(".carousel"));
    if (!carousels.length) return;

    carousels.forEach((track) => {
        const items = Array.from(track.querySelectorAll(".item"));
        if (items.length <= 1) return;

        // Progressive enhancement: only becomes horizontal when initialized.
        track.classList.add("is-carousel");
        track.setAttribute("tabindex", "0");

        const {controls, prev, next} = createControls(document);
        track.insertAdjacentElement("afterend", controls);

        let currentIndex = getClosestIndex(track, items);
        let rafId = null;

        function updateControls() {
            prev.disabled = currentIndex <= 0;
            next.disabled = currentIndex >= items.length - 1;
        }

        function scrollToIndex(index, behavior) {
            const i = clamp(index, 0, items.length - 1);
            const target = items[i];

            track.scrollTo({
                left: target.offsetLeft,
                behavior: behavior || "smooth"
            });

            currentIndex = i;
            updateControls();
        }

        function syncFromScroll() {
            if (rafId) return;
            rafId = requestAnimationFrame(() => {
                rafId = null;
                currentIndex = getClosestIndex(track, items);
                updateControls();
            });
        }

        prev.addEventListener("click", () => scrollToIndex(currentIndex - 1, "smooth"));
        next.addEventListener("click", () => scrollToIndex(currentIndex + 1, "smooth"));

        // Keyboard support when focused
        track.addEventListener("keydown", (e) => {
            if (e.key === "ArrowLeft") {
                e.preventDefault();
                scrollToIndex(currentIndex - 1, "smooth");
            } else if (e.key === "ArrowRight") {
                e.preventDefault();
                scrollToIndex(currentIndex + 1, "smooth");
            } else if (e.key === "Home") {
                e.preventDefault();
                scrollToIndex(0, "smooth");
            } else if (e.key === "End") {
                e.preventDefault();
                scrollToIndex(items.length - 1, "smooth");
            }
        });

        // Mouse / touch gestures already work via native scrolling; keep state in sync.
        track.addEventListener("scroll", syncFromScroll, {passive: true});

        // Initial state
        updateControls();

        // If layout changes (resize/fonts), keep the current slide aligned
        window.addEventListener("resize", () => {
            currentIndex = getClosestIndex(track, items);
            scrollToIndex(currentIndex, "auto");
        });
    });
}